
import Vue from 'vue'
import objectPath from 'object-path'
import moment from 'moment'
import { errorsToArray } from '@/utils/helpers'

const mutations = {
  clearState(state) {
    state.hotels = []
    state.insurances = []
    state.cancelInsurances = []
    state.excursions = []
    state.transfers = []
    state.visas = []
  },
  setMainService(state, service) {
    state.mainService = service
  },
  setDates(state, { startDate, endDate, duration }) {
    state.dates.startDate = startDate
    state.dates.endDate = endDate ?? moment(startDate, 'DD.MM.YYYY').add(duration, 'days').format('DD.MM.YYYY')
    state.dates.duration = duration
  },
  setLocation(state, { location, value }) {
    objectPath.set(state.locations, location, value)
  },
  setServiceFullForm(state, { target, form }) {
    objectPath.set(state, `${target}.form`, form)
  },
  updateServiceField(state, { target, value }) {
    if (Array.isArray(value)) {
      objectPath.set(state, target, value)

      let formTarget = target.split('.')
      formTarget.pop()
      formTarget = formTarget.join('.')

      objectPath.set(state, formTarget, { ...objectPath.get(state, formTarget) })
    } else {
      objectPath.set(state, target, value)
    }
  },
  updateServiceModuleIsLoading(state, { target, status }) {
    objectPath.set(state, `${target}.isLoading`, status)
  },
  setServiceModuleErrors(state, { target, status, errors }) {
    objectPath.set(state, `${target}.hasError`, status)
    objectPath.set(state, `${target}.errors`, errorsToArray(errors))
  },
  setServiceToAllPenalties(state, { service, serviceId, ...penalties }) {
    const hasService = Object.prototype.hasOwnProperty.call(state.allPenalties, service)

    if (!hasService) {
      state.allPenalties = {
        ...state.allPenalties,
        [service]: []
      }
    }

    const currentServiceIndex = state.allPenalties[service]
      .findIndex(x => x.serviceId === serviceId)

    if (currentServiceIndex >= 0) {
      Vue.set(state.allPenalties[service], currentServiceIndex, {
        ...penalties,
        serviceId
      })
    } else {
      state.allPenalties[service].push({
        ...penalties,
        serviceId
      })
    }
  },
  removeServiceFromAllPenalties(state, { service, serviceId }) {
    const hasService = Object.prototype.hasOwnProperty.call(state.allPenalties, service)

    if (hasService) {
      state.allPenalties[service] = state.allPenalties[service]
        .filter(x => x.serviceId !== serviceId)
    }
  },
  changeBookingLoadingStatus(state, status) {
    state.bookingIsLoading = status
  }
}

export default mutations